// This file was generated by run 'yarn generateStylesVariables'. Do not modify manually.
export const colors = {
  // BASE
  baseBlack: '#000000',
  baseWhite: '#ffffff',
  // GRAY
  gray25: '#FCFCFD',
  gray50: '#F9FAFB',
  gray100: '#F2F4F7',
  gray200: '#EAECF0',
  gray300: '#D0D5DD',
  gray400: '#98A2B3',
  gray500: '#667085',
  gray600: '#475467',
  gray700: '#344054',
  gray800: '#1D2939',
  gray900: '#101828',
  // PRIMARYINDIGO
  primaryIndigo25: '#F3F3F8',
  primaryIndigo50: '#E7E7F0',
  primaryIndigo100: '#C2C3DA',
  primaryIndigo200: '#9B9CC1',
  primaryIndigo300: '#7676A9',
  primaryIndigo400: '#5B5A97',
  primaryIndigo500: '#433E87',
  primaryIndigo600: '#3D377E',
  primaryIndigo700: '#352E73',
  primaryIndigo800: '#2E2567',
  primaryIndigo900: '#211551',
  // PRIMARYRED
  primaryRed25: '#FFF7F8',
  primaryRed50: '#FFECEF',
  primaryRed100: '#FFCFD5',
  primaryRed200: '#F19C9F',
  primaryRed300: '#E8767A',
  primaryRed400: '#F35659',
  primaryRed500: '#F94540',
  primaryRed600: '#EA3D3F',
  primaryRed700: '#D83338',
  primaryRed800: '#CB2C31',
  primaryRed900: '#BC2126',
  // GRAYWARM
  grayWarm25: '#FFFFFF',
  grayWarm50: '#F9F9F9',
  grayWarm100: '#F3F3F3',
  grayWarm200: '#EAEAEA',
  grayWarm300: '#DADADA',
  grayWarm400: '#B7B7B7',
  grayWarm500: '#979797',
  grayWarm600: '#6F6F6F',
  grayWarm700: '#5B5B5B',
  grayWarm800: '#3C3C3C',
  grayWarm900: '#1C1C1C',
  // GREEN
  green25: '#F2FDF4',
  green50: '#E5F7E8',
  green100: '#C0EBC5',
  green200: '#96DEA0',
  green300: '#64D278',
  green400: '#34C759',
  green500: '#00BC37',
  green600: '#00AD2D',
  green700: '#009A20',
  green800: '#008911',
  green900: '#006900',
  // TEAL
  teal25: '#F4FBF9',
  teal50: '#DCF4EF',
  teal100: '#A9E3D6',
  teal200: '#6DD2BB',
  teal300: '#06BFA0',
  teal400: '#00B08C',
  teal500: '#00A079',
  teal600: '#00936D',
  teal700: '#00825D',
  teal800: '#00724F',
  teal900: '#005533',
  // LIGHTBLUE
  lightBlue25: '#F5FCFF',
  lightBlue50: '#E2F6FF',
  lightBlue100: '#B6E7FD',
  lightBlue200: '#87D7FC',
  lightBlue300: '#5AC7FA',
  lightBlue400: '#3DBBF9',
  lightBlue500: '#2BAFF8',
  lightBlue600: '#28A0E9',
  lightBlue700: '#248DD5',
  lightBlue800: '#207CC1',
  lightBlue900: '#195C9E',
  // BLUE
  blue25: '#F0F9FF',
  blue50: '#E3F4FF',
  blue100: '#BBE2FF',
  blue200: '#8DD0FF',
  blue300: '#56BDFF',
  blue400: '#1DADFF',
  blue500: '#009EFF',
  blue600: '#008FFF',
  blue700: '#007BFF',
  blue800: '#1269EC',
  blue900: '#1F47CD',
  // LIGHTINDIGO
  lightIndigo25: '#F6F6FF',
  lightIndigo50: '#EBEBFB',
  lightIndigo100: '#CCCDF4',
  lightIndigo200: '#AAADEC',
  lightIndigo300: '#888DE5',
  lightIndigo400: '#6F71DE',
  lightIndigo500: '#5856D6',
  lightIndigo600: '#524DCB',
  lightIndigo700: '#4942BE',
  lightIndigo800: '#4237B2',
  lightIndigo900: '#36219E',
  // SIGHTXPURPLE
  sightxPurple25: '#F7F7FE',
  sightxPurple50: '#EAEAF5',
  sightxPurple100: '#CCCBE7',
  sightxPurple200: '#AAAAD7',
  sightxPurple300: '#8A88C7',
  sightxPurple400: '#736DBA',
  sightxPurple500: '#5F53AE',
  sightxPurple600: '#594AA3',
  sightxPurple700: '#504097',
  sightxPurple800: '#48368B',
  sightxPurple900: '#3B2376',
  // PURPLE
  purple25: '#FCF5FF',
  purple50: '#F4E7FA',
  purple100: '#E3C2F3',
  purple200: '#D19AED',
  purple300: '#BE72E5',
  purple400: '#AF52DE',
  purple500: '#A135D7',
  purple600: '#9132D0',
  purple700: '#7A2EC7',
  purple800: '#662AC0',
  purple900: '#3B25B1',
  // PINK
  pink25: '#FFF3F6',
  pink50: '#FFE9EF',
  pink100: '#FFC9D5',
  pink200: '#F8919D',
  pink300: '#F26276',
  pink400: '#FF2D54',
  pink500: '#FF0038',
  pink600: '#F70038',
  pink700: '#E50031',
  pink800: '#D80029',
  pink900: '#C9001D',
  // ORANGE
  orange25: '#FFFAF1',
  orange50: '#FFF3E0',
  orange100: '#FFDFB1',
  orange200: '#FFCA7F',
  orange300: '#FFB54C',
  orange400: '#FFA425',
  orange500: '#FF9500',
  orange600: '#FB8901',
  orange700: '#F57902',
  orange800: '#EF6902',
  orange900: '#E64D03',
  // WARNING
  warning100: '#FEF0C7',
  warning600: '#DC6803',
  warning700: '#B54708',
  // YELLOW
  yellow25: '#FFFCF0',
  yellow50: '#FFF8E0',
  yellow100: '#FFEDB0',
  yellow200: '#FFE17C',
  yellow300: '#FFD743',
  yellow400: '#FFCC00',
  yellow500: '#FFC300',
  yellow600: '#FFB500',
  yellow700: '#FF8F00',
  yellow800: '#FF8F00',
  yellow900: '#FF6D00',
  // ERROR
  error50: '#FEF3f2',
  error100: '#FEE4E2',
  error200: '#FECDCA',
  error400: '#F97066',
  error500: '#F04438',
  error600: '#D92D20',
  error700: '#B42318',
  // SUCCESS
  success50: '#ECFDF3',
  success100: '#D1FADF',
  success500: '#12B76A',
  success600: '#039855',
  success700: '#027A48'
} as const;

export const shadows = {
  shadowXS: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  shadowSM: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
  shadowMD: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
  shadowLG: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
  shadowXL: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  shadow2XL: '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
  shadow3XL: '0px 32px 64px -12px rgba(16, 24, 40, 0.14)'
} as const;

